import React from "react";
import stl from "./bubble.module.scss";
import { ICircle } from "@/store/modules/pageLayout";
import { ICmsProps } from "../Announcement/interface";
import BubbleClient from "./BubbleClient";
import FmLink from "@/ui-component/basic/FmLink";
import FmImage from "@/ui-component/basic/FmImage";
import FmIcon from "@/ui-component/basic/FmIcon";
import classnames from "classnames";
export interface IProps extends ICmsProps {
    circle: ICircle;
    styles?: Record<string, any>;
    isBtemplate?: boolean;
}

const Bubble: React.FC<IProps> = (props) => {
    const { circle,isBtemplate } = props;
    return (
        <div className={(classnames(stl["bubble"], isBtemplate && stl["bubble--btemplate"]))}>
            <BubbleClient {...props}>
                <FmLink href={circle?.href} className="bubble2_03">
                    {/* <FmImage image={circle?.img} alt="" /> */}
                    <img src={circle?.img} style={{width:'100%',height:'100%'}} alt="" />
                </FmLink>
                 <FmIcon icon="icon--close" />
            </BubbleClient>
        </div>
    );
};

export default Bubble;
